import { AuthSession } from '../domain/entities/AuthSession';
import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { SetGuestAuthSessionUseCase } from './SetGuestAuthSessionUseCase';
import { command, serviceCommands } from 'elc-service-bus';
import { AuthSessionRepository } from '../repositories/AuthSessionRepository';

export class ClearAuthSessionUseCase {
    private authSession: AuthSession;
    private authSessionRepository: AuthSessionRepository;
    constructor(authSessionRepository: AuthSessionRepository) {
        this.authSession = diContainer.get(serviceNames.authSession);
        this.authSessionRepository = authSessionRepository;
    }

    public execute = async () => {
        this.authSession.clearToken();
        void command(serviceCommands.CLEAR_USER_DATA);
        const setGuestAuthSessionUseCase = new SetGuestAuthSessionUseCase();
        await setGuestAuthSessionUseCase.execute();
        const { handleTokenStorage } = this.authSessionRepository;
        await handleTokenStorage();
    };
}
